module.exports = __webpack_public_path__ + "static/media/hd-signature.982b907b.jpg";